export const ActionTypes = {
  SET_NEWS: 'SET_NEWS'
};
